import React, { SVGProps } from 'react'
const SvgEmail = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    aria-hidden="true"
    {...props}
  >
    <path
      fill={props.fill || 'var(--color-cta)'}
      fillRule="nonzero"
      d="M18.946 6.5c.857 0 1.554.697 1.554 1.554v8.892c0 .857-.697 1.554-1.554 1.554H6.054A1.556 1.556 0 0 1 4.5 16.946V8.054c0-.857.697-1.554 1.554-1.554Zm.554 4.693-7 2.334-7-2.334v5.753c0 .274.202.504.465.547l.09.007h12.89c.306 0 .555-.25.555-.554v-5.753ZM18.946 7.5H6.054a.556.556 0 0 0-.554.554v2.085l7 2.333 7-2.333V8.054a.556.556 0 0 0-.465-.547l-.09-.007Z"
    />
  </svg>
)
export default SvgEmail
